import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEasyjetComponent } from './simple-icons-easyjet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEasyjetComponent ],
    exports:      [ SimpleIconsEasyjetComponent ],
    bootstrap:    []
})
export class SimpleIconsEasyjetModule {}
